import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'http://192.168.0.152:8000/api/reviews';

export const fetchReviews = createAsyncThunk('reviews/fetchReviews', async () => {
  try {
    const response = await axios.get(API_URL);
    return Object.values(response.data).map(item => item);
  } catch (error) {
    return Promise.reject(error.message);
  }
});

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState: {
    reviews: [], 
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.reviews = action.payload; 
        state.loading = false;
      })
      .addCase(fetchReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default reviewsSlice.reducer;
